/// <amd-module name="Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedPipelineResourcesCard" />
import * as React from "react";

import * as Resources from "Build/ArtifactsView/Resources";
import { IBuildLinkingService } from "Build/Client/Linking";
import { ConsumedArtifactDetails } from "Build/Client/Contracts/DataProvider";
import { ConsumedArtifactPropertyKeys, IConsumedArtifactsCardProps } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsResources"

import { Table, ITableColumn, TableColumnStyle, SimpleTableCell } from "VSSUI/Table";
import { Tooltip } from "VSSUI/TooltipEx";
import { Icon } from "VSSUI/Icon";
import { onClickFPS } from "VSS/Platform/FPS";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { getAssetLocation } from "VSS/Platform/Location";
import { ObservableArray } from "VSS/Core/Observable";

export class ConsumedPipelineResourcesCard extends VssComponent<IConsumedArtifactsCardProps> {

    public render(): JSX.Element {
        if (!this.props.consumedSource)
        {
            return <React.Fragment/>;
        }

        return (
            <Card
                className="bolt-table-card"
                headerIconProps={{render: this._renderIcon }}
                titleProps={{ text: this.props.consumedSource.alias + ' / # ' + this.props.consumedSource.versionName }}
                headerCommandBarItems={this._commandBarItems}
                contentProps={{ contentPadding: false }}>
                {this._jobsTable()}
            </Card>
        )
    }

    private _renderIcon = (): JSX.Element => {
        return (
            <div>
                <img
                    src={getAssetLocation(this.context.pageContext, "ms.vss-build-web/artifacts-view/icons/pipeline.svg")}
                    alt={Resources.Pipeline} />
            </div>
        );
    }

    private _jobsTable(): JSX.Element {
        const itemProvider = new ObservableArray(this.props.consumedSource.consumedArtifacts);
        return <Table itemProvider={itemProvider} columns={this._jobsTableColumns} ariaLabel={Resources.ConsumedPipelineTableText} />
    }

    private _getIcon = (): string => {
        return "Package";
    }

    private _renderNameCell = (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<ConsumedArtifactDetails>, tableItem: ConsumedArtifactDetails): JSX.Element => {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex} contentClassName="fontSizeM scroll-hidden">
                <Icon className="pipelines-icon-right-margin" iconName={this._getIcon()} />
                <div className="flex-row scroll-hidden">
                    <Tooltip overflowOnly={true} text={tableItem.artifactName}>
                        <span className="text-ellipsis fontWeightSemiBold">{tableItem.artifactName}</span>
                    </Tooltip>
                </div>
            </SimpleTableCell>
        );
    }

    private readonly _commandBarItems: IHeaderCommandBarItem[] = [
        {
            important: true,
            id: "viewDetails" + this.props.consumedSource.versionId,
            text: Resources.ViewDetails,
            onActivate: () => {
                let linkingService = this.context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
                onClickFPS(this.context.pageContext, linkingService.getBuildUrl(Number(this.props.consumedSource.versionId), "", this.props.consumedSource.properties[ConsumedArtifactPropertyKeys.ProjectId]), true);
            }
        }
    ];

    private readonly _jobsTableColumns: ITableColumn<ConsumedArtifactDetails>[] = [
        {
            id: Resources.ConsumedArtifactsNameColumn,
            width: -100,
            name: Resources.ConsumedArtifactsNameColumn,
            renderCell: this._renderNameCell,
            columnStyle: TableColumnStyle.Primary
        }
    ];
}